import React, { useState } from 'react';
import SettingsModal from './components/settingsModal';
import CookieBand from './components/cookieBand';

const CookiesPopup = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isActive, setIsActive] = useState(false);

  return (
    <div>
      <CookieBand
        setIsModalVisible={setIsModalVisible}
        setIsActive={setIsActive}
        isActive={isActive}
      />
      <SettingsModal
        isModalVisible={isModalVisible}
        setIsModalVisible={setIsModalVisible}
        setIsActive={setIsActive}
      />
    </div>
  );
};

export default CookiesPopup;
